import { bodyCopyMedium, Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { ISummaryItem, SummaryDisplayType, SurveySummaryItemType } from '../../../models';
import { ListSummaryItem, PlainTextSummaryItem, QuestionsSummaryItem, Section } from '../../common';
import { ReportingLayoutContainer } from './ReportingLayout';
import { SurveyAudiencesLayout } from './SurveyAudiencesLayout';

export const SummaryItemLayoutWrapper = styled(Section).attrs<{}>({
	className: 'tws-confirmation-summary-item-layout',
})`
	${bodyCopyMedium}
`;
SummaryItemLayoutWrapper.displayName = 'SummaryItemLayoutWrapper';

export const SummaryItem = styled.div.attrs<{}>({
	className: 'tws-confirmation-summary-item',
})``;
SummaryItem.displayName = 'SummaryItem';

export interface ISummaryItemLayoutProps {
	id: string;
	surveyId: number;
	headerText: string;
	isSurveyAdmin?: boolean;
	summaryItems: ISummaryItem[];
}

export class SummaryItemLayout extends React.Component<ISummaryItemLayoutProps> {
	constructor(props: ISummaryItemLayoutProps) {
		super(props);

		this.getSummaryItem = this.getSummaryItem.bind(this);
	}

	public render() {
		const { headerText, id, summaryItems } = this.props;

		return (
			<SummaryItemLayoutWrapper id={id} sectionHeader={headerText}>
				{summaryItems.map(this.getSummaryItem)}
			</SummaryItemLayoutWrapper>
		);
	}

	public getSummaryItem(summaryItem: ISummaryItem, key: any) {
		const lastItem = this.props.summaryItems[this.props.summaryItems.length - 1];

		return (
			<SummaryItem key={key} id={summaryItem.propertyName}>
				{this.getSummaryItemLayout(summaryItem)}
				{lastItem.propertyName !== summaryItem.propertyName && <Divider type='dashed' />}
			</SummaryItem>
		);
	}

	public getSummaryItemLayout(summaryItem: ISummaryItem) {
		switch (summaryItem.displayType) {
			case SummaryDisplayType.PlainText:
			case SummaryDisplayType.Date:
			case SummaryDisplayType.DateRange:
				return <PlainTextSummaryItem {...summaryItem} />;
			case SummaryDisplayType.List:
				return <ListSummaryItem {...summaryItem} />;
			case SummaryDisplayType.Composite:
				return this.getCompositeLayout(summaryItem);
		}
	}

	public getCompositeLayout(summaryItem: ISummaryItem) {
		switch (summaryItem.propertyName) {
			case SurveySummaryItemType.Questions:
				return <QuestionsSummaryItem {...summaryItem} isSurveyAdmin={this.props.isSurveyAdmin} />;
			case SurveySummaryItemType.SurveyReporting:
				return <ReportingLayoutContainer {...summaryItem} />;
			case SurveySummaryItemType.SurveyAudiences:
				return <SurveyAudiencesLayout {...summaryItem} surveyId={this.props.surveyId} />;
		}
	}
}
